import { reactive, watch } from 'vue'

export interface User {
  name: string
  email: string
  base: string
  device?: string
  verified: boolean
  verificationCode?: string
}

const USER_STORAGE_KEY = 'steps_user'

const user = reactive<User>(
  JSON.parse(localStorage.getItem(USER_STORAGE_KEY) || 'null') || {
    name: '',
    email: '',
    base: '',
    device: '',
    verified: false,
  }
)

watch(
  user,
  (newUser) => {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(newUser))
  },
  { deep: true }
)

export function useAuth() {
  const register = (userData: Omit<User, 'verified'>) => {
    user.name = userData.name
    user.email = userData.email
    user.base = userData.base
    user.device = userData.device ?? ''
    user.verified = false
    user.verificationCode = userData.verificationCode ?? ''
  }

  const verify = (code: string) => {
    if (user.verificationCode === code) {
      user.verified = true
      return true
    }
    return false
  }

  const logout = () => {
    user.name = ''
    user.email = ''
    user.base = ''
    delete user.device
    user.verified = false
    delete user.verificationCode
    localStorage.removeItem(USER_STORAGE_KEY)
  }

  const getInitials = () => {
    if (!user.name) return '?'
    return user.name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
  }

  return {
    user,
    register,
    verify,
    logout,
    getInitials,
  }
}
